import { render, staticRenderFns } from "./TextDashboard.vue?vue&type=template&id=3e5ccf9c&scoped=true"
import script from "./TextDashboard.vue?vue&type=script&lang=js"
export * from "./TextDashboard.vue?vue&type=script&lang=js"
import style0 from "./TextDashboard.vue?vue&type=style&index=0&id=3e5ccf9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ccf9c",
  null
  
)

export default component.exports